import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private routingEventSubscription: Subscription;
  isPageNotFound: boolean = false
  activatedRoute: any;
  isIframe = false;
  loginDisplay = false;
  enableCreateVoucher: boolean = environment.environmentName != "prod";
  useTestColor: boolean = environment.environmentName !== "prod";

  constructor() {
  }

  navbarOpen = false;

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;
  }

  ngOnDestroy(): any {
    this.routingEventSubscription?.unsubscribe();
  }
}
